import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AcessoTg from './components/tg';
import TelegramLink from './components/api/tgLink';
import './components/devtools';

const App: React.FC = () => {
  return (
    <Router>
      <div className="container">
        <div className="content">
          <div id="acesso">
            <Routes>
              <Route path="/" element={<AcessoTg />} />
              <Route path="/api/tgLink" element={<TelegramLink />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </div>
        </div>
      </div>
    </Router>
  );
};

export default App;
